import VueRouter from 'vue-router'

function OECDRouter() {
  VueRouter.apply(this, arguments)

  // Bind prototype methods to it's own context
  this.beforeEachHandler = this.beforeEachHandler.bind(this)
  this.subscriptionHandler = this.subscriptionHandler.bind(this)

  this.beforeEach(this.beforeEachHandler)

  let defaultVersionId = 1
  this.paramsInterface = {
    version: [defaultVersionId].concat(
      Array.apply(null, Array(10))
        .map((d, i) => String(i + 1))
        .filter(v => v !== defaultVersionId)
    ),
    versionName: void 0,
    mode: ['indicator', 'compare'],
    layout: ['explore', 'print', 'embedded', 'thumbnail'],
    lng: ['en'],
    // lng: ['en', 'fr'],
  }
}

OECDRouter.prototype = Object.create(VueRouter.prototype)

OECDRouter.prototype.beforeEachHandler = function(to, from, next) {
  // queryUrl synchronzation handler
  const routeName = to.name || 'cover'
  const routeParams = JSON.parse(JSON.stringify(to.params))
  const queryParams = this.parseQuery(JSON.parse(JSON.stringify(to.query)))

  if (from === VueRouter.START_LOCATION) {
    // Case when it's the first app navigation. Then subscribe the router to store changes.
    this.START_LOCATION = true
    this.queryUnsubscription = this.app.$options.store.subscribe(this.subscriptionHandler)
  } else {
    // ON subsequent navigations, overwrite the store queryParams
    this.START_LOCATION = false
    this.app.$store.commit('queryParams', queryParams)
  }

  if (to.path.match(/[a-z]+\/[0-9]+\/(indicator|compare)/)) {
    routeParams.lng = routeParams.layout
    routeParams.layout = routeParams.mode
    routeParams.mode = routeParams.versionName
    routeParams.versionName = null
  }

  let rewrite = false
  let redirect = Object.keys(this.paramsInterface)
    .map(param => {
      rewrite =
        rewrite ||
        routeParams[param] === null ||
        routeParams[param] === void 0 ||
        (Array.isArray(this.paramsInterface[param]) &&
          this.paramsInterface[param].indexOf(String(routeParams[param]).toLowerCase()) === -1)
      return param
    })
    .reduce((redirect, param) => {
      const value = routeParams[param]
      let fallback
      if (param === 'lng') {
        const usrLng = navigator.language.split('-')[0]
        fallback = this.paramsInterface.lng.includes(usrLng) ? usrLng : this.paramsInterface.lng[0]
      } else if (param === 'versionName') {
        fallback = this.app.$store.state.external.versionName || value || 'full'
      } else {
        fallback =
          this.paramsInterface[param].indexOf(String(value).toLowerCase()) >= 0
            ? value
            : this.paramsInterface[param][0]
      }
      if (rewrite) {
        redirect = redirect || {
          path: `/${routeName}/<version>/<versionName>/<mode>/<layout>/<lng>`,
        }
        const re = new RegExp(`<${param}>`)
        redirect.path = redirect.path.replace(re, fallback)
        return redirect
      }
    }, void 0)

  if (redirect !== void 0) {
    const query =
      location.hash.indexOf('?') > -1
        ? location.hash.replace(/#\/?/, '').replace(/.+(?=\?)/, '')
        : ''
    redirect.path += query
  }
  this.app.$store.commit(
    'errorBreadcrumb',
    redirect ? redirect.path : to.path + location.hash.replace(/.+(?=\?)/, '')
  )

  // Always go next
  next(redirect)
}

OECDRouter.prototype.subscriptionHandler = function(mutation, state) {
  if (
    (Object.keys(state.query).includes(mutation.type) &&
      !(state.xhrError.data || state.xhrError.api)) ||
    mutation.type === 'resetQuery'
  ) {
    // if mutation is about a query field and has no active error, force synchronization with a silent route replacement
    let query
    if (mutation.type === 'resetQuery') {
      query = mutation.payload
    } else {
      query = JSON.parse(JSON.stringify(state.query))
      query[mutation.type] = mutation.payload
    }

    // Force query completion with state.query as fallback values
    for (let key in state.query) {
      query[key] = Object.prototype.hasOwnProperty.call(query, key) ? query[key] : state.query[key]
    }

    const routeName = this.app.$route.name || 'cover'
    const version = this.app.$route.params.version
    const versionName = this.app.$route.params.versionName
    const mode = this.app.$route.params.mode
    const layout = this.app.$route.params.layout
    const lng = this.app.$route.params.lng

    const uriQuery = this.encodeQuery(query)
    if (
      // Check if quey has changed
      uriQuery.split('&').reduce((change, entry) => {
        entry = entry.split('=')
        let key = entry[0]
        let value = decodeURIComponent(entry[1])
        return (
          change ||
          (Boolean(value) ^ Boolean(this.app.$route.query[key])) === 1 ||
          (value && this.app.$route.query[key] && value !== this.app.$route.query[key])
        )
      }, false)
    ) {
      // If it is, then sync url state with the store state if thouse doesn't match after a store update
      const location = `/${routeName}/${version}/${versionName}/${mode}/${layout}/${lng}?${uriQuery}`
      this.replace(location)
    }
  }
}

OECDRouter.prototype.updateVersionName = function(versionName) {
  const routeName = this.app.$route.params.name
  const version = this.app.$route.params.version
  const mode = this.app.$route.params.mode
  const layout = this.app.$route.params.layout
  const lng = this.app.$route.params.lng
  // const query = this.encodeQuery(this.app.$route.query)

  this.push({
    params: {
      name: routeName,
      version: version,
      versionName: versionName,
      mode: mode,
      layout: layout,
      lng: lng,
    },
    replace: true,
  })
}

OECDRouter.prototype.parseQuery = function(query) {
  // Parse dimensions field as javascript object
  for (let key in query) {
    query[key] =
      query[key] === 'null' || query[key] === ''
        ? null
        : query[key] === 'false'
        ? false
        : query[key] === 'true'
        ? true
        : decodeURIComponent(query[key])
  }

  try {
    query.time = query.time.split('.').map(d => parseInt(d, 10))
  } catch (e) {
    query.time = []
  }

  try {
    query.lollipopOpts = query.lollipopOpts.split('.')
  } catch (e) {
    query.lollipopOpts = []
  }

  try {
    // Try to parse like 'couId.couId.couId' pattern where dots join country ids
    query.countries = query.countries.split('.')
  } catch (e) {
    query.countries = []
  }

  function parseBreakdowns(value) {
    return value ? Object.fromEntries(value.split('.').map(dim => dim.split(':'))) : null
  }

  query.mainBreakdowns = parseBreakdowns(query.mainBreakdowns)
  query.pairBreakdowns = parseBreakdowns(query.pairBreakdowns)
  query.sizeBreakdowns = parseBreakdowns(query.sizeBreakdowns)

  return query
}

OECDRouter.prototype.encodeQuery = function(query) {
  try {
    query.time = query.time.join('.')
  } catch (e) {
    query.time = ''
  }

  try {
    query.lollipopOpts = query.lollipopOpts.join('.')
  } catch (e) {
    query.lollipopOpts = ''
  }

  try {
    // Try to serialize countries like 'couId.couId.couId' pattern where dot chains country ids
    query.countries = query.countries.join('.')
  } catch (e) {
    query.countries = ''
  }

  function encodeBreakdowns(value) {
    return value
      ? Object.keys(value)
          .map(k => k + ':' + value[k])
          .join('.')
      : null
  }

  query.mainBreakdowns = encodeBreakdowns(query.mainBreakdowns)
  query.pairBreakdowns = encodeBreakdowns(query.pairBreakdowns)
  query.sizeBreakdowns = encodeBreakdowns(query.sizeBreakdowns)

  return Object.keys(query)
    .map(
      k =>
        encodeURIComponent(k) +
        '=' +
        encodeURIComponent(query[k] || (query[k] === false ? 'false' : ''))
    )
    .join('&')
}

OECDRouter.install = function() {
  VueRouter.install.apply(OECDRouter, arguments)
}

export default OECDRouter
